import React, { useContext } from "react";
import { MapToolWrapper } from "../__styles__/FullPageMap";
import { MapToolContext } from "./MapToolContext";

type MapToolProps = {
  children: React.ReactNode;
};

export const MapTool = ({ children }: MapToolProps) => {
  const { onMapToolEnter } = useContext(MapToolContext);

  return (
    <MapToolWrapper onMouseEnter={onMapToolEnter}>{children}</MapToolWrapper>
  );
};
